import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged
} from "firebase/auth";
import { auth } from "../../../firebase/auth.js";
import { customerConfig } from "../../../custom/customer.config.js";

const LOGIN_EMAIL_DOMAIN = customerConfig.auth?.allowedEmailDomain || import.meta.env.VITE_LOGIN_EMAIL_DOMAIN || "webs8.com";

export function normalizeEmail(value) {
  const raw = String(value || "").trim();
  return raw.includes("@") ? raw : `${raw}@${LOGIN_EMAIL_DOMAIN}`;
}


export function subscribeToAuthState(callback) {
  return onAuthStateChanged(auth, callback);
}

export async function loginWithEmail(emailOrUsername, password) {
  const email = normalizeEmail(emailOrUsername);

  try {
    const result = await signInWithEmailAndPassword(auth, email, password);
    return result.user;
  } catch (err) {
    // If account doesn't exist yet (e.g. initial setup for admin in emulator / fresh project)
    if (err.code === "auth/invalid-credential" || err.code === "auth/user-not-found") {
      try {
        const newResult = await createUserWithEmailAndPassword(auth, email, password);
        return newResult.user;
      } catch (createErr) {
        if (createErr.code === "auth/email-already-in-use") {
          throw err;
        }
        throw createErr;
      }
    }
    throw err;
  }
}

export async function logoutUser() {
  await signOut(auth);
}

export function formatAuthError(errorCode) {
  switch (errorCode) {
    case "auth/invalid-credential":
    case "auth/wrong-password":
      return "Invalid email or password.";
    case "auth/user-not-found":
      return "User account not found.";
    case "auth/invalid-email":
      return "Please enter a valid email address.";
    case "auth/network-request-failed":
      return "Network error. Please verify Firebase emulator or internet connection.";
    default:
      return "Unable to sign in. Please verify your credentials.";
  }
}
